export const slotAssignedElements = (nodes: any[]) => {
    if (!nodes || nodes.length <= 0) {
        return [];
    }
    return nodes.filter((node) => node.nodeType === Node.ELEMENT_NODE);
};